import { useState } from "react";

export const useWizard = () => {
  const [avanza, setAvanza] = useState(false);
  const [vuelve, setVuelve] = useState(false);

  const avanzar = () => {
    setAvanza(true);
  };

  const volver = () => {
    setVuelve(true);
  };

  return { avanza, vuelve, avanzar, volver };
};
